import { Task } from "@/types/task";
import { api } from "..";
import { buildQueryString } from "./utils";

export const userApi = api.injectEndpoints({
  endpoints: (build) => ({
    // 获取任务列表 task_type: once(新手任务)  daily(m每日任务)
    getTasks: build.query<Task[], {task_type: string,user_id:string}>({
      query:(params)=>`/tasks${buildQueryString(params)}`,
      transformErrorResponse: (baseQueryReturnValue, meta, arg) => baseQueryReturnValue.data,
    })
  }),
});

export const { useGetTasksQuery } = userApi;
